"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelTypes = exports.LabelTags = exports.LabelSizes = void 0;
var LabelSizes;
(function (LabelSizes) {
    LabelSizes["NONE"] = "NONE";
    LabelSizes["XSMALL"] = "xsmall";
    LabelSizes["SMALL"] = "small";
    LabelSizes["MEDIUM"] = "medium";
    LabelSizes["LARGE"] = "large";
    LabelSizes["XLARGE"] = "xlarge";
    LabelSizes["HUGEHEADING"] = "hugeheading";
    LabelSizes["LARGEHEADING"] = "largeheading";
    LabelSizes["FEATUREDPRICE"] = "featuredprice";
    LabelSizes["MEDIUMHEADING"] = "mediumheading";
    LabelSizes["MEDIUMHEADINGALTERNATE"] = "mediumheadingalternate";
    LabelSizes["SMALLHEADING30"] = "smallheading30";
    LabelSizes["SMALLHEADING24"] = "smallheading24";
    LabelSizes["SMALLHEADING24ALTERNATE"] = "smallheading24alternate";
    LabelSizes["SMALLHEADING18"] = "smallheading18";
    LabelSizes["SMALLHEADING15"] = "smallheading15";
    LabelSizes["LARGEBODY"] = "largebody";
    LabelSizes["LARGEBODYITALIC"] = "largebodyitalic";
    LabelSizes["LARGEBODYALTERNATE"] = "largebodyalternate";
    LabelSizes["EYEBROWLARGE"] = "eyebrowlarge";
    LabelSizes["MEDIUMBODY"] = "mediumbody";
    LabelSizes["MEDIUMBODYITALIC"] = "mediumbodyitalic";
    LabelSizes["MEDIUMBODYALTERNATE"] = "mediumbodyalternate";
    LabelSizes["EYEBROWSMALL"] = "eyebrowsmall";
    LabelSizes["SMALLBODY"] = "smallbody";
    LabelSizes["SMALLBODYITALIC"] = "smallbodyitalic";
    LabelSizes["LEGALCOPY"] = "legalcopy";
    LabelSizes["LABEL15WTNORMAL"] = "label15wtnormal";
    LabelSizes["LABEL15WT500"] = "label15wt500";
    LabelSizes["LABEL18WTNORMAL"] = "label18wtnormal";
    LabelSizes["LABEL18WT500"] = "label18wt500";
    LabelSizes["LABEL22WT500"] = "label22wt500";
    LabelSizes["LABEL34WT500"] = "label34wt500";
})(LabelSizes = exports.LabelSizes || (exports.LabelSizes = {}));
var LabelTags;
(function (LabelTags) {
    LabelTags["button"] = "button";
    LabelTags["div"] = "div";
    LabelTags["h1"] = "h1";
    LabelTags["h2"] = "h2";
    LabelTags["h3"] = "h3";
    LabelTags["h4"] = "h4";
    LabelTags["h5"] = "h5";
    LabelTags["h6"] = "h6";
    LabelTags["p"] = "p";
    LabelTags["span"] = "span";
})(LabelTags = exports.LabelTags || (exports.LabelTags = {}));
var LabelTypes;
(function (LabelTypes) {
    LabelTypes["SUCCESS"] = "success";
})(LabelTypes = exports.LabelTypes || (exports.LabelTypes = {}));
//# sourceMappingURL=LabelProps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Label/LabelProps.js
// module id = 15
// module chunks = 8